<template>
  <section class="pb-3">
    <div class="row my-5">
      <div class="col-sm-12">
        <div class="subject d-flex" :class="{ subHS: $route.params.grade_id === '394' }">
          <div class="subject__logo">
            <img
              v-if="$route.params.grade_id === '394'"
              class="img-responsive subject__logo-img img-hs"
              :src="subject.icon"
              alt
            />
            <img v-else class="img-responsive subject__logo-img" :src="subject.icon" alt />
          </div>
          <div :class="{ hs: $route.params.grade_id === '394' }">
            <h2 class="subject__title">
              {{ subject.name.find(item => item.lang === lang).value | deleteNumbers }}
            </h2>
            <p class="subject__info">
              <span>{{ $t('clusterC.completed') }}</span>
              - {{ subject.completed_lessons }} /
              {{ subject.total_lessons }}
            </p>
            <div class="subject__progress">
              <!-- <div class="subject__progress-bar" :style="'width: ' + subject.progress_percent + '%'"></div> -->
              <div class="subject__progress-bar" :style="'width: ' + subjectProgress + '%'"></div>
            </div>
          </div>
          <el-button v-if="gradeId!=2 && gradeId!=5" id="buttOpenDialog" type="text" @click="dialogVisible = true">{{ $t('glossary') }}  </el-button>
        </div>
      </div>
    </div>
    <List />
   
    <el-dialog
      title=""
      :visible.sync="dialogVisible"
      width="90%"
      top="1vh"
      :before-close="handleClose"
      destroy-on-close="true"
      show-close='false'
      custom-class="my-el-dialog"
    >
      <Glossary />
    </el-dialog>
  </section>
</template>
<script>
import { mapGetters } from 'vuex';
import routerMixins from '@/mixins/routes-mixing';
import List from './components/ClusterList.vue';
import Glossary from './components/Glossary';
import 'swiper/css/swiper.css';

export default {
  name:"Subjects",
  components: {
    List,
    Glossary,
  },
  data() {
    return {
      // Determina si el test esta habilitado por el tutor
      isEnabledTest: true,
      onPractice: false,
      loading: false,
      dialogVisible: false,
      hsLevel: false,
      gradeId:this.$route.params.grade_id
    };
  },
  computed: {
    ...mapGetters({
      userAuthenticated: 'userAuthenticated',
      // selectedClusterIndex: 'cluster/selectedClusterIndex',
      subject: 'subject/currentSubject',
      subjectActivityIdCurrent: 'subjectActivity/activityIdCurrent',
      lang: 'app/language',
    }),
    subjectProgress: function () {
      let progress = (this.subject.completed_lessons * parseFloat(100)) / this.subject.total_lessons;
      return progress;
    },
  },
  watch: {
    subjectActivityIdCurrent: function (newValue) {
      if (newValue) {
        this.$activity.$emit('create-cluster-activity', this.currentCluster.id);
      }
    },
    hsLevel: function () {
      if (this.$route.params.grade_id === 394) {
        console.log('params', this.$route.params.grade_id === 394);
        this.hsLevel = true;
      }
      console.log('params', this.$route.params.grade_id === 394);
      return this.hsLevel;
    },
  },
  created() {
    console.log(this.gradeId);
    // Obtiene las configuraciones del test de la base de datos
    // this.$store.dispatch('settingsFromDB').then(res => {
    //   this.getSettingsOfVuex(res);
    // });
    //change backgroundColor trow meta of router
    if(this.$route.params.level==1){
      this.$route.meta.backgroundColor='blue'
    }
    if(this.$route.params.level==2){
      this.$route.meta.backgroundColor='orange'
    }
    if(this.$route.params.level==3){
      this.$route.meta.backgroundColor='newOrange'
    }
    if(this.$route.params.level==4){
       this.$route.meta.backgroundColor='darkBlue'
    }
  },
  methods: {
    onSwiperSlideChangeTransitionStart() {
      this.lessons = [];
    },
    changeSwiperIndex() {
      const clusterIndex = this.$refs.mySwiper.$swiper.activeIndex;
      if (this.clusters[clusterIndex]) {
        // this.onFetchLessons(this.clusters[clusterIndex].id);
      }
    },
    playGame() {
      var path = routerMixins.cutRoute(this.$route.fullPath) + '/intructions/games';
      this.$router.push(path);
    },
    /** Accede al array de settings de vuex para obtener las configuraciones que corresponden al test de la materia actual */
    getSettingsOfVuex(settings) {
      var getSettingsOfTest = {};
      getSettingsOfTest = settings.filter(setting => {
        return setting.subject_path === this.$route.params.subject;
      });
      getSettingsOfTest.forEach(setting => {
        if (setting.identifier === 'test') {
          this.isEnabledTest = setting.status;
        }
      });
    },
    handleClose() {
      this.dialogVisible = false;
    },
  },
};
</script>
<style lang="scss">

.el-dialog__headerbtn{
  border-radius: 50%;
  background-color: red;
  position: absolute;
  right: 25px;
  top: 6px;
  padding: 5px;
  i{
    font-weight: 900;
    color: white !important;
    font-size: 1rem;
      
  }
}
.subject{
  position: relative;
  background-color: #ffd042;
  box-shadow: 5px 5px 10px rgba($color: #000000, $alpha: 0.4);
  border-radius: 8px;
  height: 70px;
  @media (min-width: 576px) {
    height: 90px
    }
  &:after,
  &:before{
    bottom: 100%;
    left: 20px;
     @media (min-width: 576px) {
      left: 40px}
    border: solid transparent;
    content: " ";
    height: 0;
    width: 0;
    position: absolute;
    pointer-events: none;
  }
  &:after{
    border-bottom-color: #8b8b8b;
    border-width: 15px;
    margin-left: -15px;
    }
  &:before{
    border-bottom-color: #8b8b8b;
    border-width: 15px;
    margin-left: -15px;
    }
  &__logo{
    align-items: center;
    background: #fff;
    border-bottom-left-radius: 3px;
    border-bottom-right-radius: 3px;
    border-top-right-radius: 3px;
    box-shadow: 5px 5px 15px rgba($color: #464646, $alpha: 1);
    display: flex;
    height: 90px;
    width: auto;
    min-width: 80px;
    justify-content: center;
    margin-top: -15px;
    margin-left: 20px;
    margin-right: 10px;
    padding: 5px;
    z-index: 2;
   @media (min-width: 576px) {
      margin-left: 40px;
      height: 120px;
      width: auto;
      min-width: 140px;
      }
    }
  &__logo-img{
    width: auto;
    max-height: 130px;
    max-width: 270px;
    height: 60px;
    @media (min-width: 576px) {
      height: 90px
    }
  }
  &__title{
    color: #000;
    margin-bottom: 0;
    font-family: 'latoregular';
    font-weight: 700;
    font-size: 25px;
     @media (min-width: 576px) {
      font-size: 35px
     }
  }
  &__progress{
    margin: 0.5rem 0;
    z-index: 1;
  }
  &__progress-bar{
    background: linear-gradient(to right, #97ff73, #38ca29);
    border: 2px solid #024e00;
    border-bottom-right-radius: 5px;
    height: 10px;
    }
  &__info{
    width: 100%;
     color: #fff;
    font-family: 'latoregular';
    font-size: 15px;
    font-weight: bold;
    }
}
.swiper-container{
  margin-left: -15px;
  margin-right: -15px;
 @media (min-width: 576px) {
    margin-left: unset;
    margin-right: unset;
    }
}
#glosaryLink{
  font-size: 22pt;
  margin-left: 50px;
  color: #156b96;
  cursor: pointer}
#buttOpenDialog{
  color: #156b96;
  font-size: 21pt;
  position: absolute;
  right: 40px;
  top: -7px;
  outline: none}
.el-dialog__close .el-icon .el-icon-close{
  color: red}
@media (max-width:576px){
  .img-hs{
    height: 35px}
  .subject__title{
    font-size: 21px}
  #buttOpenDialog{
    color: #156b96;
    font-size: 15pt;
    height: 10px;
    position: absolute;
    top: -9px;
    right: 5px;
    &:hover{
      color: red
      }
      }
  #glosaryLink{
    cursor: pointer;
    height: 33px
    }
  .hs{
    width: 46%
    }
  .subHS{
    height: 95px
    }
    }
</style>
